<div class="spinner spinner--inline">
  <svg
    class="spinner__svg"
    height="18"
    viewBox="0 0 17 18"
    width="17"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      class="spinner__icon"
      d="m7.69230769 0 7.69230771 3.95598761v7.91197519l-7.69230771 3.9559877-7.69230769-3.9559877v-7.91197519z"
      fill="none"
      stroke="#ff8700"
      transform="translate(1 1)"
    />
  </svg>
</div>
